import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  step: {
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    padding: '1.5rem 1.75rem',
    position: 'relative',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.05)',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: '0 8px 28px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-2px)',
    },
  },
  stepCompleted: {
    backgroundColor: '#ecfdf5',
    border: '1px solid #a7f3d0',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.25rem',
  },
  badge: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    background: 'radial-gradient(circle at 30% 30%, #818cf8, #4f46e5 70%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.125rem',
    fontWeight: 700,
    color: '#fff',
    flexShrink: 0,
    boxShadow:
      '0 6px 20px rgba(79, 70, 229, 0.35), inset 0 -2px 4px rgba(0, 0, 0, 0.15), inset 0 2px 4px rgba(255, 255, 255, 0.2)',
  },
  badgeCompleted: {
    background: 'radial-gradient(circle at 30% 30%, #4ade80, #16a34a 70%)',
    boxShadow:
      '0 6px 20px rgba(22, 163, 74, 0.35), inset 0 -2px 4px rgba(0, 0, 0, 0.15), inset 0 2px 4px rgba(255, 255, 255, 0.2)',
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 600,
    color: '#1a1a1a',
    fontSize: '1rem',
  },
  completedPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.375rem',
    fontSize: '0.75rem',
    fontWeight: 600,
    color: '#065f46',
    backgroundColor: '#dcfce7',
    border: '1px solid #86efac',
    padding: '0.5rem 1rem',
    borderRadius: '999px',
    width: '220px',
    flexShrink: 0,
  },
  description: {
    color: '#5c5e6e',
    lineHeight: 1.55,
    fontSize: '0.875rem',
  },
  button: {
    width: '220px',
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
    padding: '0.6rem 1.5rem',
    textAlign: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  connector: {
    width: '2px',
    height: '28px',
    marginLeft: '2.85rem',
    borderLeft: '2px dashed #c5cae9',
  },
  connectorCompleted: {
    borderLeft: '2px solid #22c55e',
  },
});

export default useStyles;
